import { toast } from 'sonner';
import { useUpdateJobPosition } from '../hooks/useUpdateJobPosition';
import type { UpdateJobPositionFormData } from '../schemas/jobPosition.schemas';
import type { JobPosition } from '../types/jobPosition.types';
import { transformJobPositionFormData } from './EditJobPositionDialog.utils';

export function useEditJobPositionHandlers(
  jobPosition: JobPosition | null,
  onOpenChange: (open: boolean) => void
): {
  isLoading: boolean;
  handleUpdate: (data: UpdateJobPositionFormData) => void;
} {
  const { updateJobPosition, isLoading } = useUpdateJobPosition();

  const handleSuccess = (): void => {
    toast.success('Job position updated successfully');
    onOpenChange(false);
  };

  const handleUpdate = (data: UpdateJobPositionFormData): void => {
    if (!jobPosition) return;
    const transformedData = transformJobPositionFormData(data);
    updateJobPosition(
      { id: jobPosition.id, data: transformedData },
      {
        onSuccess: handleSuccess,
        onError: () => toast.error('Failed to update job position'),
      }
    );
  };

  return { isLoading, handleUpdate };
}
